<script setup lang="ts">
  import { setProfileProperty } from '~~/assets/js/newtabpage'
  import { useNewsToggleStore } from '~/store/NewsToggle'
  import { SettingsThemeOption, useThemeStore } from '~/store/ThemeStore'
  import { sendMixpanelEvent } from '~/utils/host-browser-apis'
  import SettingsIcon from '~/assets/icons/settings_icon.svg'

  const isSettingsVisible = ref(false)

  const hideSettings = () => {
    if (isSettingsVisible.value) {
      isSettingsVisible.value = false
    }
  }
  const toggleSettingsVisibility = () => {
    isSettingsVisible.value = !isSettingsVisible.value
  }

  const route = useRoute()
  const showNewsToggle = computed(() => route.name !== 'summary')
  const newsToggleStore = useNewsToggleStore()

  const newsToggle = computed({
    get: () => newsToggleStore.newsToggle,
    set: async () => {
      newsToggleStore.updateNewsToggle()

      await sendMixpanelEvent('NtpSetting_Changed', {
        setting_name: 'news_content_toggle',
        setting_value: newsToggle.value ? 'on' : 'off',
      })

      setProfileProperty('ntp_newsTogglePosition', newsToggle.value ? 'on' : 'off')
    },
  })

  const { t } = useI18n()
  const themeOptions = [
    { label: t('settings.theme.options.automatic'), value: 'auto' },
    { label: t('settings.theme.options.light'), value: 'light' },
    { label: t('settings.theme.options.dark'), value: 'dark' },
  ]
  const themeStore = useThemeStore()
  const theme = computed({
    get: () => themeStore.theme,
    set: (value) => {
      themeStore.updateTheme(value as SettingsThemeOption)
    },
  })
</script>

<template>
  <div v-click-outside="hideSettings">
    <div class="flex cursor-pointer flex-row items-center gap-2 p-0" @click="toggleSettingsVisibility">
      <SettingsIcon />
      <span class="hidden text-footer_color hover:underline dark:text-dark_mode_grey md:block">{{
        $t('settings.label')
      }}</span>
    </div>
    <div
      class="absolute bottom-11 flex w-[348px] flex-col gap-1 rounded-lg border-[1px] border-settings_box_border bg-onelaunch_ui_shades_50 p-6 shadow-[0_4px_8px_rgba(0,0,0,0.14)] dark:bg-radio_group_text_selected_dark"
      :class="{ hidden: !isSettingsVisible }"
    >
      <template v-if="showNewsToggle">
        <div class="flex items-center justify-between">
          <span
            class="m-0 text-sm font-semibold text-onelaunch_dark_shades_100 dark:text-settings_title_dark"
            >{{ $t('settings.news.title') }}</span
          >

          <ClassicNtpSwitcher v-model="newsToggle" />
        </div>
        <p
          class="m-0 mb-3 text-left text-xs text-onelaunch_ui_shades_900 dark:text-radio_group_text_color_dark"
        >
          {{ $t('settings.news.description') }}
        </p>
      </template>
      <p
        class="m-0 text-left text-sm font-semibold text-onelaunch_dark_shades_100 dark:text-settings_title_dark"
      >
        {{ $t('settings.theme.title') }}
      </p>
      <p class="m-0 text-left text-xs text-onelaunch_ui_shades_900 dark:text-radio_group_text_color_dark">
        {{ $t('settings.theme.description') }}
      </p>

      <ClassicNtpRadioGroup v-model="theme" :options="themeOptions" class="mt-2" />
    </div>
  </div>
</template>
